import Swiper from 'swiper';
import { Autoplay, A11y } from 'swiper/modules';

/**
 * AlertTicker — Alpine.js component for the promo banner.
 * Rotates through multiple promos using Swiper autoplay + loop.
 * Only initialized when the banner contains more than one slide.
 */
window.AlertTicker = () => ({
    swiper: null,

    init() {
        this.$nextTick(() => {
            const el = this.$el.querySelector('.alert-swiper');
            if (!el) return;

            this.swiper = new Swiper(el, {
                modules: [Autoplay, A11y],
                slidesPerView: 1,
                loop: true,
                speed: 600,
                autoHeight: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                a11y: {
                    containerRoleDescriptionMessage: 'Promo ticker',
                    itemRoleDescriptionMessage: 'Promo',
                },
            });
        });
    },
});
